import { useEffect, useState } from "react";
import { Trash, Lightbulb } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDate, inr } from "@/lib/format";

export function WastageReport() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/stock/wastage", { params: { weeks: 4 } }).then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return null;
  return (
    <div className="mt-8 rounded-2xl border border-[#E7E2D6] bg-white p-5" data-testid="wastage-report">
      <div className="flex items-center gap-2 font-display text-lg font-semibold text-[#0F382C]"><Trash className="h-5 w-5" />Weekly wastage report</div>
      <p className="text-sm text-muted-foreground mb-3">Written-off batter by product, compared with how much you made that week (last 4 weeks).</p>
      {data.tips.length > 0 && (
        <div className="mb-4 rounded-xl border border-amber-200 bg-amber-50 p-3 text-sm" data-testid="wastage-tips">
          <div className="flex items-center gap-1 font-semibold text-amber-800"><Lightbulb className="h-4 w-4" />Make less of what spoils</div>
          {data.tips.map((t) => <div key={t} className="mt-1">{t}</div>)}
        </div>
      )}
      {data.weeks.length === 0 ? <div className="text-sm text-muted-foreground">No production batches in the last 4 weeks.</div> : data.weeks.map((w) => (
        <div key={w.week_start} className="mb-4" data-testid={`wastage-week-${w.week_start}`}>
          <div className="flex justify-between text-sm font-semibold"><span>Week of {fmtDate(w.week_start)}</span><span>{w.wasted} of {w.made} packs wasted · {inr(w.cost)} lost</span></div>
          <table className="mt-2 w-full text-sm">
            <thead><tr className="text-left text-xs uppercase tracking-wider text-muted-foreground"><th className="py-1">Product</th><th>Made</th><th>Wasted</th><th>%</th><th className="text-right">Cost lost</th></tr></thead>
            <tbody>
              {w.products.map((p) => (
                <tr key={p.product_id} className="border-t border-[#F1ECE0]" data-testid={`wastage-row-${w.week_start}-${p.product_id}`}>
                  <td className="py-1.5">{p.name}</td><td className="font-mono">{p.made}</td><td className="font-mono">{p.wasted}</td>
                  <td className={`font-mono ${p.pct >= 10 ? "text-rose-600 font-semibold" : ""}`}>{p.pct}%</td>
                  <td className="text-right font-mono">{inr(p.cost)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
}
